import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import Select from '@material-ui/core/Select';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../../api/appFetch.js';
import { MoboOutletMobilitySolutionsWithIdUrl } from '../../../../constants/apiUrls.js';
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';
import LanguageDropdown from '../../../Common/Dropdowns/LanguageDropdown.js';

export default class MobilitySolutionsEditing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobilitySolutionId: this.props.mobilitySolutionId !== undefined ? parseInt(this.props.mobilitySolutionId) : 0,
            id: 0,
            outletId: this.props.outletId !== undefined ? parseInt(this.props.outletId) : 0,
            outletName: "",
            language: "nl",
            description: "",
            isVisibleInPlanning: false,
            shortDescription: "",
            modifiedOn: "",
            modifiedByName: "",
            modifiedByAvatar: "",
            selectedOutletId: 0,
            loading: this.props.editedMobilitySolutionId !== undefined,
            redirect: false,
            accessibleMoboOutlets: [],
            editedMobilitySolutionId: this.props.editedMobilitySolutionId,
            requestInProgress: false,
            redirect: null,
            open: true,
            mobilitySolutionWasModified: false,
            mobilitySolutions: this.props.mobilitySolutions !== undefined ? this.props.mobilitySolutions : [],
        };
    }

    componentDidMount() {
        this.getMobilitySolutionById(this.state.mobilitySolutionId, this.state.outletId);
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/mobilitysolutions" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, "") });
    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked });
    };

    handleSubmit = () => {
        this.saveEditedMobilitySolution();
    }

    isValidForm = () => {
        const { description } = this.state;
        
        if(!description || description.trim().length === 0){
            return false;
        }

        return true;
    }

    getMobilitySolutionById = (mobilitySolutionId, outletId) => {
        if (outletId <= 0 || mobilitySolutionId <= 0) {
            return;
        }

        if ( this.state.mobilitySolutions?.length > 0) {
            for (let index = 0; index < this.state.mobilitySolutions.length; index++) {
                var item = this.state.mobilitySolutions[index];
                    if (item.id === mobilitySolutionId) {
                    this.setState({
                        language: item.language,
                        description: item.description,
                        isVisibleInPlanning: item.isVisibleInPlanning,
                        shortDescription: item.shortDescription,
                        outletId: item.moboOutletId,
                        mobilitySolution: item,
                        id: item.id,
                        loading: false,
                        modifiedOn: item.updatedOn !== null ? item.updatedOn : item.createdOn,
                        modifiedByName: item.updatedBy !== null ? item.updatedBy.firstName + " " + item.updatedBy.lastName : item.createdBy.firstName + " " + item.createdBy.lastName,
                        modifiedByAvatar: item.updatedBy != null ? item.updatedBy.avatar : item.createdBy.avatar,
                    });
                }
            }

        }
        else {
            this.setState({ requestInProgress: true });
            const url = MoboOutletMobilitySolutionsWithIdUrl(outletId);

            appFetch({
                url: url,
                onSuccess: (data) => {
                    var existsMobilitySolution = false;
                    var rowData = [];

                    data.forEach(function (row) {
                        if (row.id === mobilitySolutionId) {
                            existsMobilitySolution = true;
                            rowData = row;
                        }
                    });

                    if (existsMobilitySolution) {
                        this.setState({
                            language: rowData.language,
                            description: rowData.description,
                            isVisibleInPlanning: rowData.isVisibleInPlanning,
                            shortDescription: rowData.shortDescription,
                            outletId: rowData.moboOutletId,
                            mobilitySolution: rowData,
                            id: rowData.id,
                            loading: false,
                            modifiedOn: rowData.updatedBy !== null ? rowData.updatedOn : rowData.createdOn,
                            modifiedByName: rowData.updatedBy !== null ? rowData.updatedBy.firstName + " " + rowData.updatedBy.lastName : rowData.createdBy.firstName + " " + rowData.createdBy.lastName,
                            modifiedByAvatar: rowData.updatedBy != null ? rowData.updatedBy.avatar : rowData.createdBy.avatar,
                        });
                    }
                    else {
                        this.setState({ open: false, redirect: "/mobilitysolutions" });
                    }
                },
                onError: (data) => {
                    for (let i = 0; i < data.errors.length; i++) {
                        DisplayMessage(data.errors[i], "error");
                    }
                },
                onFinalize: () => {
                    this.setState({ requestInProgress: false });
                }
            })
        }
    }

    saveEditedMobilitySolution = () => {
        let resources = this.props.resources;

        if (this.state.description.trim().length <= 0) {
            DisplayMessage(resources["InvalidDescripton"], "error");
            return;
        }

        this.setState({ requestInProgress: true });

        const { language, description, isVisibleInPlanning, shortDescription } = this.state;

        var json = JSON.stringify({
            language: language,
            description: description,
            isVisibleInPlanning: isVisibleInPlanning,
            shortDescription: shortDescription,
        });

        const url = MoboOutletMobilitySolutionsWithIdUrl(this.state.mobilitySolutionId);

        appFetch({
            url: url,
            method: 'PUT',
            body: json,
            onSuccess: (data) => {
                if (data.id !== undefined) {
                    this.setState({
                        updateInProgress: false,
                        mobilitySolutionWasModified: true,
                        redirect: "/mobilitysolutions"
                    });

                    DisplayMessage(resources["MobilitySolutionWasSaved"], "success");
                }
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    renderModifiedByInfo = () => {
        let resources = this.props.resources;

        if (this.state.id > 0 && this.state.modifiedOn !== null) {
          return (
            <ModifiedByInfo
              resources={resources}
              modifiedByAvatar={this.state.modifiedByAvatar}
              modifiedOn={this.state.modifiedOn}
              modifiedByName={this.state.modifiedByName}
              className="mt-3"
            />
          );
        }

        return;
    }

    renderForm() {
        const { outletId, language, description, isVisibleInPlanning, shortDescription } = this.state;
        var helperTextDescription = description.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";
        var resources = this.props.resources;

        return (
            <Paper elevation={3} className="p-4 mt-3 mb-3">
                <Form>
                    <Form.Group style={{ display: "flex" }}>
                        <div className="col-md-3"></div>
                        <OutletsDropdown
                            resources={resources}
                            outlets={this.props.accessibleMoboOutlets}
                            outlet={outletId}
                            onOutletChange={this.handleChangeOutlet}
                            containerClass="col-6 helper-text-red"
                            disabled
                        />
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <LanguageDropdown
                            resources={resources}
                            language={language}
                            onLanguageChange={this.handleChange}
                            containerClass="col-6 helper-text-red"
                        />
                        <div className="col-3"></div>
                    </Form.Group>
                    
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className="col-6 helper-text-red" id="mobilitysolutions-shortDescription"
                                value={shortDescription} label={resources["ShortDescription"]}
                                variant="outlined" name="shortDescription" onChange={this.handleChange} inputProps={{ maxLength: 25 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group className="d-flex">
                        <div className="col-3"></div>
                        <ThemeProvider theme={SelectTheme}>
                            <TextField className={"col-6 " + helperTextDescription} id="mobilitysolutions-description"
                                value={description} label={resources["Description"]}
                                helperText={resources["InputOfDescriptionIsMandatory"]}
                                variant="outlined" name="description" onChange={this.handleChange} inputProps={{ maxLength: 200 }} />
                        </ThemeProvider >
                    </Form.Group>
                    <Form.Group style={{ display: "flex" }} >
                        <div className="col-md-3 "> </div>
                        <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                            control={<Checkbox id="mobilitysolutions-is-active" checked={isVisibleInPlanning} onChange={this.handleChangeCheckBox} name="isVisibleInPlanning" color="primary" />}
                            label={resources["IsVisibleInPlanning"]} />
                        <div className="col-md-4"> </div>
                    </Form.Group>
                    {this.renderModifiedByInfo()}
                </Form>
            </Paper>
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return (<div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>);
    }

    render() {
        const { redirect, open, mobilitySolutionWasModified, outletId, description, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: mobilitySolutionWasModified, outletId } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky">
                        <Toolbar>
                            <IconButton id="close-edit-MobilitySolution" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {resources["EditMobilitySolution"]}
                            </Typography>
                            <Button id="mobilitysolutions-save" disabled={isSaveButtonDisabled} color="inherit" onClick={this.handleSubmit}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}